import { Injectable, OnDestroy } from '@angular/core';
import { Observable, map } from 'rxjs';

// Add service type dependant code, this is just an example
import { ShieldWafProfile } from '@bn/api-interfaces';
import { AbstractApiService } from '@bn/shared/entities/abstracts/abstract-api.service';
import { RequestMetadata } from '@bn/shared/entities/index';
import { ShieldLogsModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ShieldApiService extends AbstractApiService implements OnDestroy {
  public constructor() {
    super();

    this.apiUrl = this.envConfig.apiUrl;
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public getShieldWafProfiles(): Observable<ShieldWafProfile[]> {
    return this.httpClient.get<{ data: ShieldWafProfile[][] }>(`${this.apiUrl}/shield/waf/profiles`).pipe(map((response) => response.data.flat()));
  }

  public getShieldLogs(shieldId: number | string, metadata?: RequestMetadata): Observable<ShieldLogsModel> {
    return this.httpClient.get<ShieldLogsModel>(`${this.envConfig.apiUrl}/shield/event-logs/${shieldId}`, {
      headers: AbstractApiService.getMetadataHeaders(metadata),
    });
  }
}
